export default {
    ca: {
        title: 'Perfil d\'usuari',
        deleteAccount: 'Eliminar compte',
        cambiarPssw: 'Canviar contrasenya', 
    },
    es: {
        title: 'Perfil de usuario',
        deleteAccount: 'Eliminar cuenta',
        cambiarPssw: 'Cambiar contraseña', 
    },
    en: {
        title: 'User profile',
        deleteAccount: 'Delete account',
        cambiarPssw: 'Change password', 
    },
};



// WEBPACK FOOTER //
// ./src/perfil/perfil-translations.js